import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Container, Row, Col, Modal } from 'reactstrap'
import {
  modalAction,
  authAction,
  employeeAction,
  clientMasterAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  clientMasterSelector,
  employeeSelector,
} from './../../selectors'
import { checkModifiedBy, searchClient } from '../../function'
import { generateButton } from '../../components/client/helpers/button'
import CustomModalMessage from '../../components/modal-message'
import { ClientTable, ClientForm, SearchBar } from '../../components/client'
import withLayout from '../../helpers/withLayout'

class ClientMasterPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getClientData')) {
      set(tempState, 'client', nextProps.getClientData)
      set(tempState, 'defaultClient', nextProps.getClientData)
      nextProps.resetGetClient()
    }
    if (get(nextProps, 'getClientByIDData')) {
      set(tempState, 'client_code', get(nextProps, 'getClientByIDData.client_code'))
      set(tempState, 'name', get(nextProps, 'getClientByIDData.name'))
      set(tempState, 'name_th', get(nextProps, 'getClientByIDData.name_th'))
      set(tempState, 'address', get(nextProps, 'getClientByIDData.address'))
      set(tempState, 'contact_name', get(nextProps, 'getClientByIDData.contact_name'))
      set(tempState, 'contact_position', get(nextProps, 'getClientByIDData.contact_position'))
      set(tempState, 'contact_phone', get(nextProps, 'getClientByIDData.contact_phone'))
      set(tempState, 'contact_email', get(nextProps, 'getClientByIDData.contact_email'))
      set(tempState, 'is_active', get(nextProps, 'getClientByIDData.is_active'))
      set(tempState, 'updated', get(nextProps, 'getClientByIDData.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'getClientByIDData.updated_by'), prevState.employeeList))
      nextProps.resetGetClientByID()
    }
    if (get(nextProps, 'createClientData.createdClient')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.showConfirm('createSuccess', get(nextProps, 'createClientData.status'), get(nextProps, 'createClientData.message'))
      nextProps.getClient(access_token)
      nextProps.resetCreateClient()
    }
    if (get(nextProps, 'editClientData.updatedClient')) {
      const access_token = localStorage.getItem('access_token')
      set(tempState, 'client_code', get(nextProps, 'editClientData.updatedClient.client_code'))
      set(tempState, 'name', get(nextProps, 'editClientData.updatedClient.name'))
      set(tempState, 'name_th', get(nextProps, 'editClientData.updatedClient.name_th'))
      set(tempState, 'address', get(nextProps, 'editClientData.updatedClient.address'))
      set(tempState, 'contact_name', get(nextProps, 'editClientData.updatedClient.contact_name'))
      set(tempState, 'contact_position', get(nextProps, 'editClientData.updatedClient.contact_position'))
      set(tempState, 'contact_phone', get(nextProps, 'editClientData.updatedClient.contact_phone'))
      set(tempState, 'contact_email', get(nextProps, 'editClientData.updatedClient.contact_email'))
      set(tempState, 'updated', get(nextProps, 'getClientByIDData.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'getClientByIDData.updated_by'), prevState.employeeList))
      set(tempState, 'isEdit', false)
      nextProps.showConfirm('editSuccess', get(nextProps, 'editClientData.status'), get(nextProps, 'editClientData.message'))
      nextProps.getClientByID(prevState.clientID, access_token)
      nextProps.getClient(access_token)
      nextProps.resetEditClient()
    }
    if (get(nextProps, 'deleteClientData.deletedClient')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.showConfirm('deleteSuccess', get(nextProps, 'deleteClientData.status'), get(nextProps, 'deleteClientData.message'))
      nextProps.getClient(access_token)
      nextProps.resetDeleteClient()
    }
    if (nextProps.getEmployeeData !== prevState.employeeList) {
      set(tempState, 'employeeList', nextProps.getEmployeeData)
    }
    return tempState
  }

  state = {
    search: '',
    rowID: '',
    client_code: '',
    name: '',
    name_th: '',
    address: '',
    contact_name: '',
    contact_position: '',
    contact_phone: '',
    contact_email: '',
    isSpan: false,
    isEdit: false,
    clientID: '',
    defaultClient: [],
    client: [],
    is_active: true,
    employeeList: [],
    sort_by: 'client_code',
    sort_order: 'desc',
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getClient(access_token)
    this.props.getEmployee(access_token)
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleClickEdit = () => {
    this.setState({ isEdit: !this.state.isEdit })
  }

  handleClickRow = (span, id, editID) => {
    this.setState({
      isSpan: span,
      clientID: id,
      rowID: editID,
      isEdit: false,
    })
    if (span) {
      const access_token = localStorage.getItem('access_token')
      this.props.getClientByID(id, access_token)
    }
  }

  handleSearch = (data) => {
    const { defaultClient } = this.state
    if (data === '') this.setState({ client: defaultClient, search: data })
    else this.setState({ client: defaultClient.filter(searchClient, data), search: data })
  }

  showCreate = () => {
    this.setState({
      name: '',
      name_th: '',
      address: '',
      contact_name: '',
      contact_position: '',
      contact_phone: '',
      contact_email: '',
      is_active: true,
      isEdit: false,
      isSpan: false,
    })
    this.props.showModal('clientForm')
  }

  showDelete = () => {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }

  cancelDelete = () => {
    this.props.hideConfirm('confirmDelete')
  }

  showDiscard = () => {
    if (this.state.isEdit) {
      this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
    } else this.handleClickRow(false, '', '')
  }

  handleDiscard = (type) => {
    switch (type) {
      case 'yes': {
        this.handleClickRow(false, '', '')
        return this.props.hideConfirm('confirmDiscard')
      }
      default: return this.props.hideConfirm('confirmDiscard')
    }
  }

  handleDelete = (type) => {
    switch (type) {
      case 'yes': {
        const access_token = localStorage.getItem('access_token')
        this.props.deleteClient(this.state.clientID, access_token)
        this.handleClickRow(false, '', '')
        return this.props.hideConfirm('confirmDelete')
      }
      default: return this.props.hideConfirm('confirmDelete')
    }
  }

  handleForm = (type) => {
    switch (type) {
      case 'delete': {
        this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
        break
      }
      default: {
        if (this.state.isEdit) this.submitForm()
        else this.handleClickEdit()
        break
      }
    }
  }

  submitForm = () => {
    const payload = {
      name_th: this.state.name_th,
      name: this.state.name,
      address: this.state.address,
      contact_name: this.state.contact_name,
      contact_position: this.state.contact_position,
      contact_phone: this.state.contact_phone,
      contact_email: this.state.contact_email,
    }
    const access_token = localStorage.getItem('access_token')
    if (this.state.isEdit) this.props.editClient(this.state.clientID, payload, access_token)
    else this.props.createClient(payload, access_token)
    this.props.hideModal('clientForm')
  }

  sortBy = (type, order) => {
    this.setState({ sort_by: type, sort_order: order ? 'asc' : 'desc' })
  }

  sortClient = (data) => {
    let client = data
    if (this.state.search !== '') client = client.filter(searchClient, this.state.search)
    if (this.state.sort_by === 'client_code') return orderBy(client, ['client_code'], [this.state.sort_order])
    else if (this.state.sort_by === 'name') return orderBy(client, ['name'], [this.state.sort_order])
    else if (this.state.sort_by === 'contact_name') return orderBy(client, ['contact_name'], [this.state.sort_order])
    else if (this.state.sort_by === 'contact_position') return orderBy(client, ['contact_position'], [this.state.sort_order])
    return client
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) return generateButton('success', () => this.props.hideConfirm(confirmType))
    else if (confirmStatus === 'Discard Changes') return generateButton('discard', (type) => this.handleDiscard(type))
    else if (confirmStatus === 'Delete Comfirmation') return generateButton('delete', (type) => this.handleDelete(type))
    else if (confirmStatus === 'Error') return generateButton('error', () => this.props.hideConfirm(confirmType))
    return null
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsSalesUser = get(this.props, 'authData.user.is_salesman_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectClient.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectClient.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      IsSalesUser !== undefined &&
      IsAccountantUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser || IsSalesUser || IsAccountantUser)) window.location = '/home'

    const confirmType = get(this.props, 'confirmType')
    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmMessage = get(this.props, 'confirmMessage')
    const modalType = get(this.props, 'modalType')
    const isFetching = get(this.props, 'getIsFetchingClient')
    || get(this.props, 'getIsFetchingEmployee')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <SearchBar
          toggleCreate={ this.showCreate }
          handleSearch={ this.handleSearch }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <Row noGutters>
          <CustomModalMessage
            hide={ () => this.props.hideConfirm(confirmType) }
            show={
              confirmType === 'createSuccess'
              || confirmType === 'editSuccess'
              || confirmType === 'deleteSuccess'
              || confirmType === 'confirmDiscard'
              || confirmType === 'confirmDelete'
            }
            type={ confirmStatus }
            message={ confirmMessage }
            button={ this.selectButton(confirmStatus, confirmType) }
          />
          <Row noGutters>
            <Col>
              <ClientTable
                handleInput={ this.handleInput }
                handleClickRow={ this.handleClickRow }
                sortBy={ this.sortBy }
                clients={ this.sortClient(this.state.client) }
                { ...this.state }
              />
            </Col>
            { this.state.isSpan &&
              <Col>
                <ClientForm
                  handleInput={ this.handleInput }
                  button={ generateButton('form', (type) => this.handleForm(type), this.state.isEdit) }
                  { ...this.state }
                  handleClickRow={ this.handleClickRow }
                  cancelForm={ () => this.props.hideModal('clientForm') }
                  showDelete={ this.showDelete }
                  cancelDelete={ this.cancelDelete }
                  showDiscard={ this.showDiscard }
                  cancelDiscard={ this.cancelDiscard }
                />
              </Col>
            }
          </Row>
          <Modal
            isOpen={ modalType === 'clientForm' }
            toggle={ () => this.props.hideModal('clientForm') }
          >
            <ClientForm
              create={ true }
              button={ generateButton('create', () => this.submitForm()) }
              { ...this.state }
              handleInput={ this.handleInput }
              cancelForm={ () => this.props.hideModal('clientForm') }
            />
          </Modal>
        </Row>
      </Wrapper>
    )
  }
}

ClientMasterPage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  getClient: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getClientByID: PropTypes.func.isRequired,
  editClient: PropTypes.func.isRequired,
  createClient: PropTypes.func.isRequired,
  deleteClient: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectClient: clientMasterSelector.redirectClient,
  getIsFetchingClient: clientMasterSelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getClientData: clientMasterSelector.getClientData,
  getClientByIDData: clientMasterSelector.getClientByIDData,
  editClientData: clientMasterSelector.editClientData,
  createClientData: clientMasterSelector.createClientData,
  deleteClientData: clientMasterSelector.deleteClientData,
  getEmployeeData: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getClient: clientMasterAction.getClient,
  resetGetClient: clientMasterAction.resetGetClient,
  getClientByID: clientMasterAction.getClientByID,
  resetGetClientByID: clientMasterAction.resetGetClientByID,
  editClient: clientMasterAction.editClient,
  resetEditClient: clientMasterAction.resetEditClient,
  createClient: clientMasterAction.createClient,
  resetCreateClient: clientMasterAction.resetCreateClient,
  deleteClient: clientMasterAction.deleteClient,
  resetDeleteClient: clientMasterAction.resetDeleteClient,
  getEmployee: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ClientMasterPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/client/index.js